/**
 * UIInputType enum.
 */
export var UIInputType;
(function (UIInputType) {
    UIInputType["BROWSE_FILE"] = "BrowseFile";
    UIInputType["TEXT_BOX"] = "TextBox";
    UIInputType["BROWSE_FOLDER"] = "BrowseFolder";
    UIInputType["DATE_PICKER"] = "DatePicker";
    UIInputType["SELECT_DROPDOWN"] = "SelectDropdown";
    UIInputType["MULTI_SELECT_DROPDOWN"] = "MultiSelectDropdown";
    UIInputType["TOGGLE"] = "Toggle";
    UIInputType["BUTTON"] = "Button";
})(UIInputType || (UIInputType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVUlJbnB1dFR5cGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbGliL2VudW1zL1VJSW5wdXRUeXBlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOztHQUVHO0FBQ0gsTUFBTSxDQUFOLElBQVksV0FTWDtBQVRELFdBQVksV0FBVztJQUNyQix5Q0FBMEIsQ0FBQTtJQUMxQixtQ0FBb0IsQ0FBQTtJQUNwQiw2Q0FBOEIsQ0FBQTtJQUM5Qix5Q0FBMEIsQ0FBQTtJQUMxQixpREFBa0MsQ0FBQTtJQUNsQyw0REFBNkMsQ0FBQTtJQUM3QyxnQ0FBaUIsQ0FBQTtJQUNqQixnQ0FBaUIsQ0FBQTtBQUNuQixDQUFDLEVBVFcsV0FBVyxLQUFYLFdBQVcsUUFTdEIifQ==